import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { RiMenuLine } from "react-icons/ri";

const LayoutAdmin = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-[calc(100vh-5rem)] bg-secondary-100 text-white">
      {/* Botón hamburguesa solo en móviles */}
      {!sidebarOpen && (
        <button
          className="xl:hidden fixed top-4 left-4 z-50 bg-secondary-300 p-2 rounded shadow-md hover:bg-secondary-900 transition-colors"
          onClick={() => setSidebarOpen(true)}
        >
          <RiMenuLine className="text-white text-2xl" />
        </button>
      )}

      {/* Capa oscura para cerrar el sidebar al hacer clic fuera */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 z-40 xl:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
      {/* Header */}
      <div className="fixed top-0 left-0 xl:left-64 right-0 h-16 bg-secondary-300 z-40">
        <Header />
      </div>
      {/* Sidebar controlado desde Layout */}
      <Sidebar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />

      <div className="pt-20 xl:ml-64 p-4 min-h-[calc(100vh-5rem)]">
        <Outlet />
      </div>
    </div>
  );
};

export default LayoutAdmin;
